import api from "@/services/api";

const { get, post } = api.getPrefixedMethods("mentions");

export default {
  listMentions(page = 1) {
    return get("", { params: { page } });
  },
  createMention({ recipientIds, message, orderKey, intakeDocumentKey, intakeOrderId }) {
    return post("", {
      recipientIds,
      message,
      orderKey,
      intakeDocumentKey,
      intakeOrderId,
    });
  },
  markRead(id) {
    return post(`${id}/read`);
  },
  markUnread(id) {
    return post(`${id}/unread`);
  },
  markAllRead() {
    return post("read-all");
  },
  getUnreadCount() {
    return get("unread-count");
  },
};
